export default __webpack_public_path__ + "static/media/imageScreenFimOnboarding.99ba21d1.png";